import { Action } from '@ngrx/store';
import { ShippingCondition } from '@cemex-core/cmx-api/models/shipping-conditions/shipping-condition';

export enum OneClickShippingMethodActionTypes {
  LOAD = '[One Click] Load shipping methods',
  LOAD_COMPLETE = '[One Click] Load shipping methods completed',
  SELECT = '[One Click] Select shipping methods',
  RESET = '[One Click] Shipping methods reset',
}

export class OneClickLoadShippingMethodAction implements Action {
  readonly type = OneClickShippingMethodActionTypes.LOAD;

  constructor() {}
}

export class OneClickLoadShippingMethodCompleteAction implements Action {
  readonly type = OneClickShippingMethodActionTypes.LOAD_COMPLETE;

  constructor(public payload: ShippingCondition[]) {}
}

export class OneClickSelectShippingMethodAction implements Action {
  readonly type = OneClickShippingMethodActionTypes.SELECT;

  constructor(public payload: ShippingCondition) {}
}

export class OneClickResetShippingMethodAction implements Action {
  readonly type = OneClickShippingMethodActionTypes.RESET;

  constructor() {}
}

export type OneClickShippingMethodActions =
  | OneClickLoadShippingMethodAction
  | OneClickLoadShippingMethodCompleteAction
  | OneClickSelectShippingMethodAction
  | OneClickResetShippingMethodAction;
